import {
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Login from "../component/Auth/Login/container";
import ForgotPassword from "../component/Auth/ForgotPassword/container";
import AuthenticatedRoute from "../component/AuthenticatRoute/index";
import ForgotOTP from "../component/Auth/ForgotOTP/container";
import { useEffect, useState } from "react";
import Home from "../component/Home/container";
import { createBrowserHistory } from "history";
import ReduxToastr from "react-redux-toastr";
import { Loginpopup } from "../component/Auth/LoginPopup/Loginpopup";
import ChangePassword from "../component/Auth/ChangePassword/container";
import "../../node_modules/react-redux-toastr/lib/css/react-redux-toastr.min.css";
import UserBasicContainer from "../component/Navigation/UsersRoleComp/UserDetails/container";
import CouponDeatilsContainer from "../component/CouponDetails/container.js";
import CreateUser from "../component/UserCreate/container.js";
import CohortContainer from "../component/AddCohort/container.js";
import AddWarehouseContainer from "../component/AddWarehouseComp/container";
import { SuccessComp } from "../component/UserCreate/successComp";
import UpdateCohortContainer from "../component/Navigation/UsersRoleComp/UpdateUserDetails/UpdateCohort/container";
import UpdateWarehouseContainer from "../component/Navigation/UsersRoleComp/UpdateUserDetails/UpdateWareHouse/container";
import UpdateUserDetails from "../component/Navigation/UsersRoleComp/UpdateUserDetails/container";
import OrderListContainer from "../component/OrderComp/OrdersList/container";
import { LandingPage } from "../component/Auth/Grettingpage/component";
import OrdersViewContainer from "../component/OrderComp/OrdersDetails/container";
import UserPermissionContainer from "../component/UserPermission/container";
import CouponListContainer from "../component/CouponList/container.js";
import Changepasswordsuccess from "../component/Auth/ChangepasswordSuccess/component";
import OrdersRefundContainer from "../component/OrderComp/OrderRefund/container";
import CouponContainer from "../component/CouponComp/CouponCreate/container";
import CouponDesContainer from "../component/CouponComp/CouponDescription/container";
import CouponImageContainer from "../component/CouponComp/CouponImage/container";
import CouponDateContainer from "../component/CouponComp/CouponDate/container";
import CouponDeeplinkContainer from "../component/CouponComp/CouponDeepLink/container";
import CouponAmountContainer from "../component/CouponComp/CouponAmount/container";
import CouponTypeContainer from "../component/CouponComp/CouponType/container";
import CouponCashbackContainer from "../component/CouponComp/CouponCashback/container";
import { CouponCashbackDiscountComponent } from "../component/CouponComp/CouponDiscount/component";
import CouponVMContainer from "../component/CouponComp/CouponVM/container";
import CouponAplicableItemContainer from "../component/CouponComp/CouponAplicableItem/container";
import CouponPGContainer from "../component/CouponComp/CouponPG/container";
import CouponUseDurationContainer from "../component/CouponComp/CouponUseDuration/container";
import CouponLimitContainer from "../component/CouponComp/CouponLimit/container";
import CouponDiscountCompContainer from "../component/CouponComp/CouponDiscountComp/container";
import CouponFreegiftContainer from "../component/CouponComp/CouponFreeGift/container";
import CouponSuccessContainer from "../component/CouponComp/CouponSuccess/container";
import CouponTimeSlot from '../component/CouponComp/CouponTimeSlot/container.js'
import CouponDeviceLimitContainer from "../component/CouponComp/CouponDeviceLimit/container.js";
import CouponStartDateContainer from "../component/CouponComp/CouponStartDate/container.js";
import CouponHiddeNContainer from "../component/CouponComp/CouponHidden/container.js";
import BrandcategorizationContainer from "../component/walletsAndTags/BrandCategorization/container";
import VMRsuggestionContainer from "../component/VMComponent/VMRefillSuggestion/container";
import CouponTermandConditionContainer from "../component/CouponComp/CouponT&C/container";
import ConfigurepayoutContainer from "../component/Configuration/ConfigurePayout/container";
import CreateFranchiesComponent from "../component/Configuration/ConfigurePayout/CreateFranchies/component";
import ManagePartnersListContainer from "../component/Configuration/ManagePartner/ManagePartnerList/container";
import ManagePartnersDetailsContainer from "../component/Configuration/ManagePartner/ManagePartnerDetails/container";
import UpdateCohortDetailsContainer from "../component/Configuration/UpdateCohortDetails/container";
import UpdateFranchiseeDetailsContainer from "../component/Configuration/UpdateFranchiseeDetails/container";
import UpdateBankDetailsContainer from "../component/Configuration/UpdateBankDetails/container";
import UpdateMapChargesContainer from "../component/Configuration/UpdateMapCharges/container";
import TagpayListContainer from "../component/walletsAndTags/TagpayManagement/TagpayList/container";
import TagpayCreateContainerV2 from "../component/walletsAndTags/TagpayManagement/CreateTagpay/container";
import TagpayDetailsContainerV2 from "../component/walletsAndTags/TagpayManagement/TagpayListDetails/container";
import TagpayListComponent from "../component/walletsAndTags/TagpayManagement/TagpayList/component";
import TagpayListContainerV2 from "../component/walletsAndTags/TagpayManagementV2/TagpayListV2/container.js";
import TagpayCreateContainer from "../component/walletsAndTags/TagpayManagement/CreateTagpay/container";
import TagpayDetailsContainer from "../component/walletsAndTags/TagpayManagement/TagpayListDetails/container";
// import TagpayListComponent from "../component/walletsAndTags/TagpayManagement/TagpayList/component";
import BPListContainer from "../component/CustomerManager/BPManagement/BPList/container";
import BPCreateContainer from "../component/CustomerManager/BPManagement/CreateBP/container";
import VmCreateContainer from "../component/Configuration/VMCreation/NewVMCreation/container";
import VmCreateContainer2 from "../component/Configuration/VMCreation1/NewVMCreation/container.js";
import VmListContainer from "../component/Configuration/VMCreation/VmList/container";
import VmListContainer2 from "../component/Configuration/VMCreation/VmList2/container";
import VMDetailsContainer from "../component/Configuration/VMCreation/VMDetails/container";
import VMDecomissionContainer from "../component/Configuration/VMCreation/VMDecomission/container";
import VMCloneContainer from "../component/Configuration/VMCreation/VMClone/container";
import VmEditContainer from "../component/Configuration/VMCreation/VMEditDetails/container";
import ReportAndAnalysticsListContainer from "../component/OrderComp/ReportAndAnalystics/container";
import ScreensaversListContainer from "../component/ScreenSaversComp/container";
import DaalchiniPointsListContainer from "../component/walletsAndTags/DaalchiniPointComp/container";
import CohortListContainer from "../component/VMComponent/CohortsComp/CohortCompList/container.js";
import WarehouseContainer from "../component/VMComponent/WarehouseComp/container"
import ProductListContainer from "../component/VMComponent/ProductComp/container"
import ProductVariantDetailsContainer from "../component/VMComponent/ProductComp/ProductVariantDetails/container.js"
import CreateMfidContainer from "../component/VMComponent/ProductComp/CreateMFIDComp/container"
import UpdateMfidContainer from "../component/VMComponent/ProductComp/EditMFIDComp/container";
import CreateVendorContainer from "../component/VMComponent/ProductComp/CreateVendorComp/container.js";
import CohortCreationContainer from "../component/VMComponent/CohortsComp/CohortCreationComp/container.js";
import CohortViewContainer from "../component/VMComponent/CohortsComp/CohortDetailsComp/container.js";
import ComboListContainer from "../component/ComboComp/container.js"
import ComboCreateContainer from "../component/ComboComp/ComboCreationComp/container.js";
import ComboDetailsContainer from "../component/ComboComp/ComboDetailsComp/container.js"
import ComboCohortAddContainer from "../component/ComboComp/UpdateComboCohortComp/container.js";
import ComboDetailsUpdateContainer from "../component/ComboComp/UpdateComboItemDetailsComp/container.js";
import UpdateNewCharges from "../component/Configuration/UpdateNewCharges/container.js";
import CohortAddVMContainer from "../component/VMComponent/CohortsComp/CohortAddVM/container.js";
import CohortAddUserContainer from "../component/VMComponent/CohortsComp/CohortAddUser/container.js";
import CohortUpdateDetailsContainer from "../component/VMComponent/CohortsComp/CohortUpdateDetails/container.js";
import WarehouseAssortmentListContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentList/container.js"
import WarehouseassortmentCreationContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentCreation/container.js"
import WarehouseNewAssortmentCreationContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentCreationFlow/container.js";
import WarehouseNewAssortmentRuleCreationContainer from "../component/Assortments/WarehouseAssortment/WarehouseRuleCreation/container.js";
import CohortAssortmentListContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentList/container.js";
import CohortAssortmentListDetailsContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentListDetails/container.js";
import WarehouseAssortmentDetailsContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentDetails/container.js";
import BPUserDetailsContainer from "../component/CustomerManager/BPManagement/BPListDetails/container.js";
import AddBPUserContainer from "../component/CustomerManager/BPManagement/AddNewBPUserCreation/container.js";
import BulkUploadSummary from "../component/CustomerManager/BPManagement/AddNewBPUserCreation/BulkUploadSummery.js";
import CohortNewAssortmentCreationContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentCreation/container.js";
import CohortAssortmentDetailsContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentDetails/container.js";
import WarehouseAssortmentUpdateContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentUpdate/container.js";
import CohortNewRuleCreationContainer from "../component/Assortments/CohortsAssortment/CohortRuleCreation/container.js";
import CohortAssortmentUpdateContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentUpdate/container.js";
import WarehouseRuleUpdateContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentRuleUpdate/container.js";
import CohortRuleUpdateContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentRuleUpdate/container.js";
import WarehouseAssortmentCloneContainer from "../component/Assortments/WarehouseAssortment/WarehouseAssortmentClone/container.js";

import CohortAssortmentCloneContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentClone/container.js";
import PayoutPartnerContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerPayoutList/container.js";
import ScheduledPayoutContainer from "../component/PayoutSatelment/PayoutSatelmentComp/ScheduledPayout/container.js";
import ScheduleReportContainer from "../component/PayoutSatelment/PayoutSatelmentComp/SchedulePayoutReportDownload/container.js";
import PayoutViewSettlementContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerViewSettlement/container.js";
import PartnerListContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerList/container.js";
import PartnerBillSummaryContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerBillSummery/container.js";
import PartnerBillDetailsContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerPayoutBillDetails/container.js";
import AddMiscellaneousChargeContainer from "../component/PayoutSatelment/PayoutSatelmentComp/AddMiscellaneousCharge/container.js"
import PostBillsContainer from "../component/PayoutSatelment/PayoutSatelmentComp/ViewPastBill/container.js";
import PartnerInactiveBillDetailsContainer from "../component/PayoutSatelment/PayoutSatelmentComp/PartnerPayoutBillInactive Details/container.js";
import StopPayoutContainer from "../component/PayoutSatelment/PayoutSatelmentComp/StopPayoutComponent/container.js";
import PartnerPastBillsContainer from "../component/PayoutSatelment/ForPartner/ViewPastBill/container.js";
import PartnerBlockListContainer from "../component/PayoutSatelment/PayoutSatelmentComp/UnblockPayoutComp/container.js";

import Cst_Roster_Container from "../component/Cst_Rooster_List/container.js";
import Create_Cst_Roster_Container from '../component/Create_Cst_Roster/container.js'
import Product_Expiry_Container from "../component/ProductExpiryComp/ProductExpiryList/container.js"
import Product_Expiry_List_Container from "../component/ProductExpiryComp/ProductExpiryListDetails/container.js"
import ScheduleMarkSettleDownloadReportContainer from "../component/PayoutSatelment/PayoutSatelmentComp/ScheduledMarkSettle/container.js";
import UidDashboardContainer from "../component/VMConfigurationDashboard/UidDashboard/container.js";
import VmidDashboardContainer from "../component/VMConfigurationDashboard/VMDashboard/container.js";
import UidDashboardDetailsContainer from "../component/VMConfigurationDashboard/UidDashboard/UidDashboardDetails/container.jsx";
import UidDashboardTimelineContainer from "../component/VMConfigurationDashboard/UidDashboard/UidTimeLinedetails/conatiner.js";
import ListOfCreatedUid from "../component/VMConfigurationDashboard/UidDashboard/ListOfcreatedUids/ListofCreatedUids.jsx";
import BulkUpload from "../component/VMConfigurationDashboard/UidDashboard/UIDBulkUpload/component.js";
import BulkUploadContainer from "../component/VMConfigurationDashboard/UidDashboard/UIDBulkUpload/container.js";
import VmIdDashboardContainer from "../component/VMConfigurationDashboard/VMDashboard/container.js";
import VmidDashboardDetailsContainer from "../component/VMConfigurationDashboard/VMDashboard/UidDashboardDetails/container.jsx";
// import Product_BrandList_Container from "../component/ProductRestructure/ProductBrandListComp/container.js";
import CorporateListContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/CorporateList/container.js";
import CorporateCreateContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/CreateCorporate/container.js";
import CorporateDashboardContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/CorporateDashboard/container.js";

import CorporateUserDetailsContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/BPListDetails/container.js";
import AddCorporateUserContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/AddNewBPUserCreation/container.js";
import CorporateDepartmentListContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/TotalDepartment/container.js";
import CorporateDepartmentRuleListContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/DepartmentRule/DepartmentRuleList/container.js";
import CreateRuleContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/DepartmentRule/CreateDepartmentRuleComp/container.js";
import EditRuleContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/DepartmentRule/UpdateRuleComponent/container.js";
import RechargeHistoryContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/DepartmentRule/RechargeRuleHistory/container.js";
import UsageLimitContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/UsageLimit/container.js";
import PayoutDateContainer from "../component/DFPayoutComp/DFPayoutCreateComp/container.js";
import PayoutHistoryContainer from "../component/DFPayoutComp/DFPayoutList/container.js";
import CorporateUpdateContainer from "../component/CorporateOnBoarding/DaalchiniAdmin/UpdateCorporateDetails/container.js";
import TagPayDashboardContainer from "../component/walletsAndTags/TagpayManagementV2/TagpayManagementDashboard/container.js";
import CreateBulkTagContainer from "../component/walletsAndTags/TagpayManagementV2/AddandActiveTag/container.js";
import TagViewDetailsContainer from "../component/walletsAndTags/TagpayManagementV2/ViewTagDetails/container.js";
import TagUsageHistoryContainer from "../component/walletsAndTags/TagpayManagementV2/TagUsageHistory/container.js";
import NavigationalListContainer from "../component/NavigationalComponent/NavigationalList/container.js";
import NavigationalUpdateContainer from "../component/NavigationalComponent/NavigationalDetails/container.js";
import NavigationalCreateContainer from "../component/NavigationalComponent/NavigationalCreate/container.js";
import ProductCategoriesContainer from "../component/ProductRestructure/ProductCategoriesListComp/container.js";
import CategoryCreationComponent from "../component/ProductRestructure/CategoryCreationComp/component.js";
import CategoryCreateContainer from "../component/ProductRestructure/CategoryCreationComp/container.js";
import CategoryEditContainer from "../component/ProductRestructure/ProductCategoryDetailsComponent/container.js";
import SubCategoryListComponent from "../component/ProductRestructure/SubCategoryListComponent/component.js";
import SubCategoryCreateComponent from "../component/ProductRestructure/SubCategoryCreateComp/component.js";
// import CohortAssortmentCloneContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentClone/";


// import CohortAssortmentCloneContainer from "../component/Assortments/CohortsAssortment/CohortAssortmentClone/container.js";

/* ANKIT -----------------------END */

function App() {
  const [auth, setAuth] = useState(localStorage.getItem("data"));
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("data")
  );
  const navigate = useNavigate();
  useEffect(() => {
    const storedData = localStorage.getItem("data");
    setIsAuthenticated(storedData);

    if (!storedData && window.location.pathname.startsWith("/home")) {
      navigate("/");
    }
  }, [navigate]);

  //const shouldRenderChangePassword = !isAuthenticated;
  const history = createBrowserHistory();
  console.log("auth -----");

  return (
    <div>
      <Routes history={history}>
        {/* <Route path="/" element={<Login />} />
        <Route path="/home" element={<AuthenticatedRoute element={<LandingPage />} />} /> */}
        <Route path="/" element={<Login />} />
        <Route
          path="/home/*"
          element={
            isAuthenticated ? <LandingPage /> : <Navigate to="/" replace />
          }
        />

        <Route
          path="/forgetpassword"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <ForgotPassword />
          }
        />
        {/* <Route path="/changepassword" exact element={<ChangePassword />} /> */}

        <Route path="/forgototp" exact element={<ForgotOTP />} />
        <Route path="/changepassword" exact element={<ChangePassword />} />
        <Route path="/loginpopup" exact element={<Loginpopup />} />
        <Route
          path="/home/users/list"
          exact
          element={<UserPermissionContainer />}
        />
        <Route
          path="/home/coupon/list"
          exact
          element={<CouponListContainer />}
        />

        <Route path="/createuser" exact element={<CreateUser />} />
        <Route path="/createcohort" exact element={<CohortContainer />} />
        <Route path="/addwarehouse" exact element={<AddWarehouseContainer />} />
        <Route path="/successpage" exact element={<SuccessComp />} />
        <Route
          path="/changepasswordsuccess"
          exact
          element={<Changepasswordsuccess />}
        />

        {/* Orders module start */}

        <Route exact path="/home/ordersview" element={<OrderListContainer />} />
        <Route
          exact
          path="/users/userlist/:userid"
          element={<UserBasicContainer />}
        />
        <Route
          exact
          path="/home/coupon/:couponid"
          element={<CouponDeatilsContainer />}
        />
        <Route
          path="/home/ordersview/:orderid"
          element={<OrdersViewContainer />}
        />

        <Route
          path="/home/orderview/manualrefund/:pg_name/:id/:source"
          element={<OrdersRefundContainer />}
        />

        {/* Orders module end           */}

        <Route
          path="/updateuserdetails/:userid"
          element={<UpdateUserDetails />}
        />
        <Route
          path="/updatecohortdetails/:userid"
          element={<UpdateCohortContainer />}
        />
        <Route
          path="/updatewarehouse/:userid"
          element={<UpdateWarehouseContainer />}
        />

        {/* Coupon start */}

        <Route path="/home/couponcreate" element={<CouponContainer />} />

        <Route
          path="/home/coupondescription"
          element={<CouponDesContainer />}
        />
        <Route path="/home/couponimage" element={<CouponImageContainer />} />

        <Route path="/home/coupondate" element={<CouponDateContainer />} />
        <Route
          path="/home/coupondeeplink"
          element={<CouponDeeplinkContainer />}
        />
        <Route
          path="/home/coupondiscountamount"
          element={<CouponAmountContainer />}
        />
        <Route path="/home/coupontype" element={<CouponTypeContainer />} />
        <Route
          path="/home/couponcashback"
          element={<CouponCashbackContainer />}
        />
        <Route
          path="/home/couponcashbackdiscount"
          element={<CouponCashbackDiscountComponent />}
        />
        <Route path="/home/couponvmcreation" element={<CouponVMContainer />} />

        <Route
          path="/home/couponaplicableitem"
          element={<CouponAplicableItemContainer />}
        />
        <Route path="/home/couponpg" element={<CouponPGContainer />} />
        <Route
          path="/home/couponuseduration"
          element={<CouponUseDurationContainer />}
        />
        <Route path="/home/couponlimit" element={<CouponLimitContainer />} />
        <Route
          path="/home/coupondiscountcomp"
          element={<CouponDiscountCompContainer />}
        />
        <Route
          path="/home/couponfreegift"
          element={<CouponFreegiftContainer />}
        />
        <Route
          path="/home/couponsuccess"
          element={<CouponSuccessContainer />}
        />
        <Route
          path="/home/coupontnc"
          element={<CouponTermandConditionContainer />}
        />
        <Route path="/home/CouponDeviceUsage" element={<CouponDeviceLimitContainer />} />
        <Route path="/home/CouponHidden" element={<CouponHiddeNContainer />} />
        <Route path="/home/couponstartdate" element={<CouponStartDateContainer />} />
        <Route path="/home/coupontimeslot" element={<CouponTimeSlot />} />
        {/* Coupon end */}
        <Route
          path="/home/brandcategorization"
          element={<BrandcategorizationContainer />}
        />

        <Route
          path="/home/refillsuggestion"
          element={<VMRsuggestionContainer />}
        />

        <Route
          path="/home/configuration/managepartners"
          element={<ManagePartnersListContainer />}
        />
        <Route
          path="/home/configuration/managepartnersdetails/:id/:cohortId/:franchiseeId"
          element={<ManagePartnersDetailsContainer />}
        />

        <Route
          path="/home/createfranchies"
          element={<ConfigurepayoutContainer />}
        />

        <Route
          path="/home/updatecohortdetails/:cohortId"
          element={<UpdateCohortDetailsContainer />}
        />
        <Route
          path="/home/updatefranchiseedetails/:franchiseeId"
          element={<UpdateFranchiseeDetailsContainer />}
        />
        <Route
          path="/home/updatebankdetails/:franchiseeId"
          element={<UpdateBankDetailsContainer />}
        />
        <Route
          path="/home/updatemapcharges/:franchiseeId"
          element={<UpdateMapChargesContainer />}
        />
        <Route
          path="/home/updatenewmapcharges/:franchiseeId"
          element={<UpdateNewCharges />}
        />

        <Route
          path="/home/walletandtag/tagpymanagement"
          element={<TagpayListContainer />}
        />
        <Route
          path="/home/walletandtag/tagpymanagementdetails/:seriesId"
          element={<TagpayDetailsContainer />}
        />

        <Route
          path="/home/walletandtag/tagpymanagement/createtagpay"
          element={<TagpayCreateContainer />}
        />

        <Route
          path="/home/customermanager/bpmanagementlist"
          element={<BPListContainer />}
        />
{/* tagpay management V2 routes */}

  <Route
          path="/home/walletandtag/tagpymanagementv2"
          element={<TagpayListContainerV2 />}
        />
        <Route
          path="/home/walletandtags/tagpay-dashboard/:corporateId"
          element={<TagPayDashboardContainer />}
        />

      
         <Route
          path="/home/walletandtag/tagpymanagementv2/createtagpay"
          element={<TagpayCreateContainerV2 />}
        />
        <Route
          path="/home/walletandtag/tagpymanagementv2/create-bulk-tag/:corporateId/:pgid"
          element={<CreateBulkTagContainer />}
        />
        <Route
          path="/home/walletandtag/tagpymanagementv2/view-tag/:corporateId/:pgid"
          element={<TagViewDetailsContainer />}
        />
         <Route
         path= "/home/walletandtags/tag-usage-history/:uid"
          element={<TagUsageHistoryContainer />}
        />
   





        {/* corporate route */}

         <Route
          path="/home/customermanager/corporatelist"
          element={<CorporateListContainer />}
        />
         <Route
          path="/home/customermanager/editcorporatedetails/:corporateId"
          element={<CorporateUpdateContainer />}
        />
         <Route
          path="/home/customermanager/createcorporate"
          element={<CorporateCreateContainer />}
        />
         <Route
          path="/home/customermanager/corporatedashboard/:corporateId"
          element={<CorporateDashboardContainer />}
        />
           <Route
          path="/home/customermanager/departments/:corporateId"
          element={<CorporateDepartmentListContainer />}
        />

  <Route
          path="/home/customermanager/corporate/rules/:corporateId"
          element={<CorporateDepartmentRuleListContainer />}
        />
         <Route
          path="/home/customermanager/corporate/add-rule/:corporateId"
          element={<CreateRuleContainer />}
        />
        


        <Route
          path="/home/customermanager/bpmanagement/createcorporate"
          element={<BPCreateContainer />}
        />
    <Route
          path="/home/customermanager/bpmanagementlist/corporatemanagementuserdetails/:corporateId"
          element={<CorporateUserDetailsContainer />}
        />
 <Route
          path="/home/customermanager/corporate/edit-rule/:corporateId/:departmentId"
          element={<EditRuleContainer />}
        />
        
         <Route
          path="/home/customermanager/recharge-history/:corporateId"
          element={<RechargeHistoryContainer />}
        />
          <Route
          path="/home/customermanager/usage-limit/:corporateId"
          element={<UsageLimitContainer />}
        />

       
         <Route
          path="/home/customermanager/bpmanagementlist/bpmanagementuserdetails/:id"
          element={<BPUserDetailsContainer />}
        />  
           <Route
          path="/home/customermanager/bpmanagementlist/bpmanagementusercreation/:id"
          element={<AddBPUserContainer />}
        />
        <Route
          path="/home/customermanager/bpmanagementlist/corporatemanagementusercreation/:corporateId"
          element={<AddCorporateUserContainer />}
        />
        <Route
          path="/home/customermanager/bpmanagementlist/bpmanagementusersummery"
          element={<BulkUploadSummary />}
        />

        <Route
          path="/home/configuration/vmcreation/newvmcreation"
          element={<VmCreateContainer />}
        />
        <Route
          path="/home/configuration/vmcreation/newvmcreation2"
          element={<VmCreateContainer2 />}
        />
        <Route
          path="/home/configuration/vmlist"
          element={<VmListContainer />}
        />
        <Route
          path="/home/configuration/vmlist2"
          element={<VmListContainer2 />}
        />
        <Route
          path="/home/configuration/vmdetails/:id"
          element={<VMDetailsContainer />}
        />
        <Route
          path="/home/configuration/vmdecomission/:id"
          element={<VMDecomissionContainer />}
        />
        <Route
          path="/home/configuration/vmclone/:id"
          element={<VMCloneContainer />}
        />
        <Route
          path="/home/configuration/vmeditdetails/:vmId"
          element={<VmEditContainer />}
        />
        <Route
          path="/home/reportsandanalytics"
          element={<ReportAndAnalysticsListContainer />}
        />
        <Route
          path="/home/addcenter/screensavers"
          element={<ScreensaversListContainer />}
        />
        <Route
          path="/home/walletsandtags/daalchinipoints"
          element={<DaalchiniPointsListContainer />}
        />
        <Route
          path="/home/configuration/cohortslist"
          element={<CohortListContainer />}
        />
        <Route
          path="/home/configuration/cohortdetails/:id"
          element={<CohortViewContainer />}
        />
        <Route
          path="/home/configuration/cohortadddetails/:id"
          element={<CohortUpdateDetailsContainer />}
        />
        <Route
          path="/home/configuration/cohortaddvm/:id"
          element={<CohortAddVMContainer />}
        />
        <Route
          path="/home/configuration/cohortadduser/:id"
          element={<CohortAddUserContainer />}
        />
        <Route
          path="/home/configuration/warehouse"
          element={<WarehouseContainer />}
        />
        <Route
          path="/home/configuration/products"
          element={<ProductListContainer />}
        />
        <Route
          path="/home/configuration/productsvariantdetails/:variantId"
          element={<ProductVariantDetailsContainer />}
        />
        <Route
          path="/home/configuration/productsvariantdetails/createmfid/:variantId"
          element={<CreateMfidContainer />}
        />
        <Route
          path="/home/configuration/productsvariantdetails/updatemfid/:id/:variantId"
          element={<UpdateMfidContainer />}
        />
        <Route
          path="/home/configuration/productsvariantdetails/createnewvendor"
          element={<CreateVendorContainer />}
        />
        <Route
          path="/home/configuration/cohort/cohortcreation"
          element={<CohortCreationContainer />}

        />


        <Route
          path="/home/combolist"
          element={<ComboListContainer />}

        />
        <Route
          path="/home/combodetails/:comboId"
          element={<ComboDetailsContainer />}

        />
        <Route
          path="/home/comboCreation"
          element={<ComboCreateContainer />}

        />
        <Route
          path="/home/comboupdatecohort/:comboId"
          element={<ComboCohortAddContainer />}

        />
        <Route
          path="/home/comboupdatedetails/:comboId"
          element={<ComboDetailsUpdateContainer />}

        />
        {/* Assortment component  start*/}

        <Route
          path="/home/assortment/assortmentwarehouse"
          element={<WarehouseAssortmentListContainer />}

        />

        <Route
          path="/home/assortment/assortmentwarehousecreation/:reference_id"
          element={<WarehouseassortmentCreationContainer />}

        />
        <Route
          path="/home/assortment/newassortmentwarehousecreation/:reference_id"
          element={<WarehouseNewAssortmentCreationContainer />}

        />
        <Route
          path="/home/assortment/newassortmentrulecreation/:reference_id"
          element={<WarehouseNewAssortmentRuleCreationContainer />}

        />
        <Route
          path="/home/assortment/assortmentdetails/:assortmentId"
          element={<WarehouseAssortmentDetailsContainer />}

        />
        <Route
          path="/home/assortment/assortmenteditdetails/:assortmentId"
          element={<WarehouseAssortmentUpdateContainer />}

        />
        <Route
          path="/home/assortment/clone/:assortmentId"
          element={<WarehouseAssortmentCloneContainer />}

        />
        <Route
          path="/home/assortment/warehouse/rule/edit/:ruleId"
          element={<WarehouseRuleUpdateContainer />}
        />


        {/* cohort Assortment */}
        <Route
          path="/home/assortment/assortmentcohortlist"
          element={<CohortAssortmentListContainer />}

        />
        <Route
          path="/home/assortment/assortmentcohortlistdetails/:reference_id"
          element={<CohortAssortmentListDetailsContainer />}

        />
        <Route
          path="/home/assortment/newassortmentcohortcreation/:reference_id"
          element={<CohortNewAssortmentCreationContainer />}
        />
        <Route
          path="/home/assortment/cohortassortmentdetails/:assortmentId/:reference_id"
          element={<CohortAssortmentDetailsContainer />}

        />
         <Route
          path="/home/assortment/cohortassortmentdetails/:assortmentId"
          element={<CohortAssortmentDetailsContainer />}

        />

        <Route
          path="/home/assortment/cohortassortmenteditdetails/:assortmentId"
          element={<CohortAssortmentUpdateContainer />}

        />
        <Route
          path="/home/assortment/cohort/rule/edit/:ruleId"
            />
        <Route
          path="/home/assortment/newcohortassortmentrulecreation/:reference_id"
          element={<CohortNewRuleCreationContainer />}
        />

        <Route
          path="/home/cohort/assortment/clone/:assortmentId"
          element={<CohortAssortmentCloneContainer />}

        />
        {/* Partner Payout */}
        <Route
          path="/home/configuration/payoutpartners"
          element={<PayoutPartnerContainer />}

        />
        <Route
          path="/home/configuration/payoutpartners"
          element={<PayoutPartnerContainer />}

        />
        <Route
          path="/home/configuration/payoutpartners/scheduled/:date"
          element={<ScheduledPayoutContainer />}

        />
        <Route
          path="/home/configuration/payoutpartners/schedule/download-report"
          element={<ScheduleReportContainer />}
        />
        <Route
          path="/home/configuration/payoutpartners/marksettle/schedule/download-report/:date"
          element={<ScheduleMarkSettleDownloadReportContainer />}
        />
        <Route
          path="/home/configuration/payoutpartners/viewsettle"
          element={<PayoutViewSettlementContainer />}

        />
        <Route
          path="/home/configuration/payoutpartners/partnerlist"
          element={<PartnerListContainer />}

        />
        <Route
          path="/home/configuration/partner/bills/summery/:billId"
          element={<PartnerBillSummaryContainer />}

        />
        <Route
          path="/home/configuration/partner/bills/details/:billId"
          element={<PartnerBillDetailsContainer />}

        />
        <Route
          path="/home/configuration/partner/bills/view-past-bill-details/:billId"
          element={<PartnerInactiveBillDetailsContainer />}

        />
        <Route
          path="/home/configuration/partner/bills/miscellaneous-charge"
          element={<AddMiscellaneousChargeContainer />}

        />
        <Route
          path="/home/configuration/partner/bills/post-bills/:franchiseeId"
          element={<PostBillsContainer />}

        />
        <Route
          path="/home/configuration/partner/block-payout"
          element={<StopPayoutContainer />}

        />
        <Route
          path="/home/configuration/partner/block-payout-list"
          element={<PartnerBlockListContainer />}

        />

        {/* For Partner */}

        <Route
          path="/home/configuration/forpartners"
          element={<PartnerPastBillsContainer />}

        />


        <Route
          path="/cst_rooster"
          element={<Cst_Roster_Container />}
        />

        <Route
          path="/create_cst_rooster"
          element={<Create_Cst_Roster_Container />}
        />





        {/* ANKIT  ----------------------START */}
        <Route
          path="/home/assortment/assortmentwarehouse"
          element={<WarehouseAssortmentListContainer />}
        />
        <Route
          path="/home/assortment/assortmentwarehousecreation/:reference_id"
          element={<WarehouseassortmentCreationContainer />}
        />
        <Route
          path="/home/assortment/newassortmentwarehousecreation/:reference_id"
          element={<WarehouseNewAssortmentCreationContainer />}
        />
        <Route
          path="/home/assortment/newassortmentrulecreation/:reference_id"
          element={<WarehouseNewAssortmentRuleCreationContainer />}
        />
        <Route
          path="/home/assortment/assortmentdetails/:assortmentId/:reference_id"
          element={<WarehouseAssortmentDetailsContainer />}
        />
        <Route
          path="/home/assortment/assortmenteditdetails/:assortmentId"
          element={<WarehouseAssortmentUpdateContainer />}
        />
        <Route
          path="/home/assortment/cohort/clone/:assortmentId"
          element={<CohortAssortmentCloneContainer />}
        />
        <Route
          path="/home/assortment/warehouse/rule/edit/:ruleId"
          element={<WarehouseRuleUpdateContainer />}
        />
        {/* cohort Assortment */}
        <Route
          path="/home/assortment/assortmentcohortlist"
          element={<CohortAssortmentListContainer />}
        />
        <Route
          path="/home/assortment/assortmentcohortlistdetails/:reference_id"
          element={<CohortAssortmentListDetailsContainer />}
        />
        <Route
          path="/home/assortment/newassortmentcohortcreation/:reference_id"
          element={<CohortNewAssortmentCreationContainer />}
        />
        {/* <Route
          path="/home/assortment/cohortassortmentdetails/:assortmentId/:reference_id"
          element={<CohortAssortmentDetailsContainer />}
        /> */}
        <Route
          path="/home/assortment/cohortassortmenteditdetails/:assortmentId"
          element={<CohortAssortmentUpdateContainer />}
        />
        <Route
          path="/home/assortment/cohort/rule/edit/:ruleId"
          element={<CohortRuleUpdateContainer />}
        />
        <Route
          path="/home/assortment/newcohortassortmentrulecreation/:reference_id"
          element={<CohortNewRuleCreationContainer />}
        />
        <Route
          path="/home/cohort/assortment/clone/:assortmentId"
          element={<CohortAssortmentCloneContainer />}
        />
        {/* ANKIT -----------------------END */}
        {/* Product Expiry-----------------------start */}

        <Route
          path="/home/configuration/productlist"
          element={<Product_Expiry_Container />}
        />
        <Route
          path="/home/configuration/productlist/details/:id"
          element={<Product_Expiry_List_Container />}
        />
        {/* Product Expiry-----------------------end */}
        {/* Uid mapping-----------------------start */}

        <Route
          path="/home/configuration/uid-dashboard"
          element={<UidDashboardContainer />}
        />
        <Route
          path="/home/configuration/vmid-dashboard"
          element={<VmidDashboardContainer />}
        />
        <Route
          path="/home/configuration/uid-details/:uid"
          element={<UidDashboardDetailsContainer />}
        />
        <Route
          path="/home/configuration/vmid-details/:uid"
          element={<VmidDashboardDetailsContainer />}
        />
        <Route
          path="/home/configuration/uid-dashboard/uid-timeline/:uid"
          element={<UidDashboardTimelineContainer />}
        />
        <Route
          path="/home/configuration/uid-dashboard/new-created-list"
          element={<ListOfCreatedUid />}
        />
        {/* Add these new routes for mapping/unmapping */}
        <Route
          path="/home/configuration/uid-unmap/:uid"
          element={<UidDashboardDetailsContainer />}
        />
        <Route
          path="/home/configuration/uid-map/:uid"
          element={<UidDashboardDetailsContainer />}
        />
        <Route
          path="/home/configuration/bulk-upload"
          element={<BulkUploadContainer />}
        />



        <Route
          path="/home/configuration/vmid-dashboard"
          element={<VmIdDashboardContainer />}
        />

 {/* Add these new routes for product restructure */}
  <Route
          path="/home/configuration/product-restructure"
          element={<ProductCategoriesContainer />}
        />
        <Route
          path="/home/product/categories/create"
          element={<CategoryCreateContainer />}
        />
 <Route
          path="/home/product/categories/edit/:id"
          element={<CategoryEditContainer />}
        />
 <Route
          path="home/product/categories/subcategories/:id"
          element={<SubCategoryListComponent />}
        />
         <Route
          path="/home/product/categories/subcategories/create/:id"
          element={<SubCategoryCreateComponent />}
        />
         <Route
          path="/home/product/categories/subcategories/edit/:id"
          element={<SubCategoryCreateComponent />}
        />


{/* Df payout report----start */}

         <Route
          path="/home/dfpayout/dfpayoutcreate"
          element={<PayoutDateContainer />}
        />
         <Route
          path="/home/dfpayout/dfpayoutlist"
          element={<PayoutHistoryContainer />}
        />

{/* Navigational routes */}

  <Route
          path="/home/navigational/list"
          element={<NavigationalListContainer />}
        />
         <Route
          path="/home/navigational/create"
          element={<NavigationalCreateContainer />}
        />
         <Route
          path="/home/navigational/update/:id"
          element={<NavigationalUpdateContainer />}
        />


        
         
      </Routes>

      <ReduxToastr
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick={false}
      />




    </div>
  );
}

export default App;
